module.exports = __webpack_public_path__ + "media/scholarships/instant-apply-icon-972fb6a0.svg";